import { toProductCardVM } from '@lib/util/to-product-card-vm';
import type { HttpTypes } from '@medusajs/types';
import ProductPreview from '@modules/products/components/product-preview';
import EmblaCarousel from './embla-carousel-client';
import ProductSliderHeader, { type CtaLink } from './product-slider-header';

const SLIDE_CLASS =
  'flex-[0_0_76%] mobile:flex-[0_0_calc(50%-6px)] desktop:flex-[0_0_calc(33.333%-8px)] xl:flex-[0_0_269px] min-w-0 pl-3 last:mr-4 desktop:last:mr-0';

const PREV_BUTTON_STYLE = { backgroundColor: '#e1e3db' };
const NEXT_BUTTON_STYLE = {
  background:
    'linear-gradient(0deg, rgba(23,240,222,0.27) 0%, rgba(23,240,222,0.27) 100%), #fff',
};

const BUTTON_CLASS =
  'flex items-center justify-center w-10 h-10 rounded-full transition-colors duration-200 disabled:opacity-40 disabled:cursor-not-allowed';

const DEFAULT_CTAS: CtaLink[] = [
  {
    label: 'Shop all treatments',
    href: '/search',
    variant: 'primary',
  },
];

type ProductSliderProps = {
  products: HttpTypes.StoreProduct[];
  overline?: string | null;
  description?: string;
  title?: string;
  ctas?: CtaLink[] | null;
};

const ProductSlider = ({
  products,
  overline = 'Bestsellers',
  title = 'Popular treatments, ready to ship',
  description,
  ctas = DEFAULT_CTAS,
}: ProductSliderProps) => {
  if (!products || products.length === 0) {
    return null;
  }

  const cards = products.map(toProductCardVM);

  return (
    <section
      aria-labelledby="product-slider-heading"
      className="bg-surface-neutral-subtle overflow-x-clip"
    >
      <div className="content-container py-8 desktop:py-10 flex flex-col gap-6">
        <ProductSliderHeader
          overline={overline}
          title={title}
          description={description}
          ctas={ctas}
        />

        <EmblaCarousel
          slideClassName={SLIDE_CLASS}
          trackGap="-ml-3"
          prevButtonClassName={BUTTON_CLASS}
          nextButtonClassName={BUTTON_CLASS}
          prevButtonStyle={PREV_BUTTON_STYLE}
          nextButtonStyle={NEXT_BUTTON_STYLE}
          prevAriaLabel="Previous products"
          nextAriaLabel="Next products"
        >
          {cards.map((card) => (
            <ProductPreview key={card.id} card={card} />
          ))}
        </EmblaCarousel>
      </div>
    </section>
  );
};

export default ProductSlider;
